module.exports = __webpack_public_path__ + "static/media/Rep_Krishnamoorthi_0.7d1a2b58.jpg";